import React from "react";

import classNames from "classnames";

import Icon from "../Icon";

const TemplateCard = ({ className, icon, title, disabled, onClick }) => {
  const classes = classNames({
    "relative z-0 flex rounded-xl overflow-hidden h-48": true,
    "cursor-pointer": !disabled,
    "cursor-not-allowed opacity-50": disabled,
  });
  return (
    <div
      className={`${classes} ${className}`}
      onClick={onClick}
      aria-hidden="true"
    >
      <div className="flex flex-col w-full h-full items-center justify-center">
        <Icon name={icon} width={62} height={62} strokeWidth="3px" />
        <p className="text-xl mt-2 capitalize">{title}</p>
      </div>
    </div>
  );
};

export default TemplateCard;
